/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditReportsGetGipMetadataCustomFieldsQueryResponse, AuditReportsGetGipMetadataCustomFields401, AuditReportsGetGipMetadataCustomFields403 } from "../models/AuditReportsGetGipMetadataCustomFields";

export function getAuditReportsGetGipMetadataCustomFieldsUrl() {
  const res = { method: 'GET', url: `/audit-reports/v1/reports/gip/metadata/custom-fields` as const }
  return res
}

/**
 * @summary Return GIP custom field keys for the client
 * {@link /audit-reports/v1/reports/gip/metadata/custom-fields}
 */
export async function auditReportsGetGipMetadataCustomFields(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<AuditReportsGetGipMetadataCustomFieldsQueryResponse, ResponseErrorConfig<AuditReportsGetGipMetadataCustomFields401 | AuditReportsGetGipMetadataCustomFields403>, unknown>({ method : "GET", url : getAuditReportsGetGipMetadataCustomFieldsUrl().url.toString(), ... requestConfig })
  return res.data
}